import styled, { css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

const MIN_BLOCK_WIDTH = 160;

export const StyledContainer = styled.div`
  width: 100%;
  display: grid;
  height: max-content;
  overflow-y: auto;
  grid-template-columns: repeat(
    auto-fill,
    minmax(${({ theme }) => utils.rem(MIN_BLOCK_WIDTH - theme.Spacing.Size.XSmall)}, 1fr)
  );
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
`;

export const StyledFormatWrapper = styled.div`
  position: relative;
`;

export const StyledTagContainer = styled.div`
  position: absolute;
  ${({ theme }) => css`
    right: 0;
    top: ${utils.rem(theme.Spacing.Size.XSmall)};
  `}
`;
